<script>
    import { noteStore } from '../../stores';
    import { config } from '../../../scripts/defaultURL';
    import { clearForm, formatPayloadDate } from '../../../scripts/functions';
    import { updateData } from '../../../scripts/rest';

    export let note;

    let payload = {
        id: note.id ,
        client_id: note.client_id,
        date: formatPayloadDate(note.date),
        note: note.note
    };
    
    function closeModal() {
        clearForm('#addScanModal input');
        payload = {
            id: note.id ,
            client_id: note.client_id,
            date: formatPayloadDate(note.date),
            note: note.note
        };
        document.getElementById('editNoteModal').classList.remove('is-active')
        $noteStore['todo'] = 'getData'
    }  
  
    function save() {
        console.log('payload',payload);
  
        updateData(`${config.defaultURL}/notes/update/` + payload.id, payload)
        .catch((error) => console.error('Failed to update note:', error))
        .then((res) => {
            console.log(res)
            closeModal()
        })
    }
  </script>
  
<style>
    .modal-card-title {
        margin-bottom: 0 !important;
    }
</style>
    
<div class="modal" id="editNoteModal">
    <div class="modal-background" />
    <div class="modal-card">
        <header class="modal-card-head">
        <p class="modal-card-title">Edit Note</p>
        <button on:click={closeModal} class="delete" aria-label="close" />
        </header>
        <section class="modal-card-body">
            <div class="field">
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label class="label">Date</label>
                <input disabled bind:value={payload.date} class="input" type="date" name="date" placeholder="Enter Scan Date" required />
            </div>
            <div class="field">
                <!-- svelte-ignore a11y-label-has-associated-control -->
                <label class="label">Note</label>
                <textarea bind:value={payload.note} class="textarea" name="note"></textarea>
            </div>
            <div class="field is-grouped">
                <div class="control">
                    <button on:click={save} class="button is-primary">Save</button>
                </div>
                <div class="control">
                    <button
                    on:click={closeModal}
                    class="button is-primary is-light">Cancel</button>
                </div>
            </div>      
        </section>
    </div>
</div>
    